import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79588abb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "footer" }

import {
  Notifications,
  NotificationActions,
  NotificationType,
} from '@/typings/notification';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import TimeSince from './TimeSince.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    uuid: null,
    notification: null
  },
  emits: ["dismiss"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dismiss', uuid: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  uuid: number;
  notification: Notifications;
}





const container = ref<HTMLElement>();

function onDismiss() {
  container.value?.classList.remove('visible');
  // Wait until after the slide-out animation is finished
  setTimeout(() => {
    emit('dismiss', props.uuid);
  }, 500);
}

const router = useRouter();

function view() {
  if (props.notification.type === NotificationType.ScoreUpdate) {
    const { slug } = props.notification.meta;
    router.push(`/card/${slug}`);
    onDismiss();
  }
}

onMounted(() => {
  // Wait until mounted to add visible to handle animations
  setTimeout(() => {
    container.value?.classList.add('visible');
  }, 0);
});

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['container'] = _value
      container.value = _value
    },
    class: "pws-notification"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.notification.title), 1),
        _createVNode(TimeSince, {
          start: __props.notification.sentAt,
          class: "sub-title"
        }, null, 8, ["start"])
      ]),
      _createElementVNode("button", { onClick: onDismiss }, [
        _createVNode(_component_fa_icon, { icon: "times" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.notification.body), 1),
    _createElementVNode("div", _hoisted_4, [
      (__props.notification.actions.includes(_unref(NotificationActions).View))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: view
          }, " View "))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})